import { Component, OnInit, OnDestroy, Input, OnChanges } from '@angular/core';
import { PoiService, Poi } from '../poi.service';
import { Subscription } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { MetaService } from 'src/app/meta.service';

@Component({
  selector: 'app-poi-list',
  templateUrl: './poi-list.component.html',
  styleUrls: ['./poi-list.component.sass']
})
export class PoiListComponent implements OnInit, OnDestroy, OnChanges {
  @Input() category?: string;
  @Input() municipality?: string

  sub = new Subscription();
  private allPois: Poi[] = [];
  pois: Poi[] = [];
  lastCategoryLoad = ""

  constructor(
    private poiService: PoiService, 
    private metaService: MetaService
    ) { }

  ngOnInit() {
    this.sub.add(this.poiService.loadPois().subscribe(pois => {
      this.allPois = pois;
      this.filterPois();
    }));
  }

  filterPois() {
    // console.log(`filter category: ${this.category} municipality: ${this.municipality}`);
    this.pois = this.allPois.filter(poi => {
      if (this.category && this.municipality) {
        return poi.category.toLowerCase() === this.category.toLowerCase() &&
                poi.municipality.toLowerCase() === this.municipality.toLowerCase();
      }
      else if (this.category) {
        return poi.category.toLowerCase() === this.category.toLowerCase();
      }
      else if (this.municipality) {
        return poi.municipality.toLowerCase() === this.municipality.toLowerCase();
      }
      else {
        return true;
      }
    });
  }

  ngOnChanges() {
    this.filterPois();
    this.metaService.setListTitle(this.category, this.municipality);
  }

  getUrl(poi: Poi) {
    return poi.category.toLowerCase() + "/" + this.metaService.slugify(poi.name) + "-" + poi.id;
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
